//@ts-nocheck

const postCategoryFilter = () => {
  const postsSection = document.querySelector('.js-posts-section')
  if (!postsSection) return

  const postsList = postsSection.querySelector('.js-posts-list')
  const categoryBtns = postsSection.querySelectorAll('.js-post-category-button')
  if (!postsList || categoryBtns.length === 0) return

  document.addEventListener('DOMContentLoaded', function () {
    const seeAllBtn = document.querySelector('.see-all-button')
    const anchor = document.getElementById('category-anchor')
    const categoryContainer = document.querySelector(
      '.insights-page__category-buttons'
    ) // Add container selector

    const isMobile = window.innerWidth <= 800

    if (seeAllBtn && anchor && categoryContainer) {
      let isExpanded = false // Track toggle state
      const hiddenCats = document.querySelectorAll(
        '.insights-page__category-button.is-hidden'
      )
      if (isMobile) {
        seeAllBtn.textContent = 'CATEGORIES [+]'
      } else {
        seeAllBtn.textContent = 'CATEGORIES'
      }
      const originalBtnText = seeAllBtn.textContent // Store original button text

      if (isMobile) {
        seeAllBtn.addEventListener('click', function (e) {
          e.preventDefault()
          const anchorTop =
            anchor.getBoundingClientRect().top + window.scrollY - 50

          if (!isExpanded) {
            // Show hidden categories
            hiddenCats.forEach((catBtn, i) => {
              setTimeout(() => {
                catBtn.classList.remove('is-hidden')

                if (i === hiddenCats.length - 1) {
                  setTimeout(() => {
                    window.scrollTo({
                      top: anchorTop,
                      behavior: 'smooth',
                    })
                    seeAllBtn.textContent = 'CATEGORIES [-]'
                    isExpanded = true
                  }, 25)
                }
              }, i * 50)
            })
          } else {
            const visibleCats = Array.from(hiddenCats).reverse()

            visibleCats.forEach((catBtn, i) => {
              setTimeout(() => {
                catBtn.classList.add('is-hidden')

                if (i === visibleCats.length - 1) {
                  setTimeout(() => {
                    window.scrollTo({
                      top: anchorTop,
                      behavior: 'smooth',
                    })
                    seeAllBtn.textContent = originalBtnText
                    isExpanded = false
                  }, 25)
                }
              }, i * 50)
            })
          }
        })
      }
    }
  })

  categoryBtns.forEach((btn) => {
    const btnCategory = btn.dataset.category
    btn.addEventListener('click', () => {
      loadPosts(btnCategory)

      categoryBtns.forEach((catBtn) => {
        if (catBtn !== btn) {
          catBtn.classList.remove('active')
        } else {
          catBtn.classList.add('active')
        }
      })

      if (window.innerWidth <= 800) {
        const top = postsList.getBoundingClientRect().top + window.scrollY - 50
        window.scrollTo({ top, behavior: 'smooth' })
      }
    })
  })

  async function loadPosts(category = null) {
    try {
      let formData = new FormData()
      formData.append('action', 'fa_load_posts')
      if (category) formData.append('category', category)

      postsSection.classList.add('loading')

      const response = await fetch(ajaxurl, {
        method: 'POST',
        body: formData,
      })

      const res = await response.json()
      postsList.innerHTML = res.data

      postsSection.classList.remove('loading')
    } catch (e) {
      console.log('An error occured')
      postsSection.classList.remove('loading')
    }
  }
}

export default postCategoryFilter
